import React from "react";
import { useLocation } from "react-router-dom";
import ALPRDetailInfo from "../../components/Detail/_ALPRDetailInfo";

function useQuery() {
    return new URLSearchParams(useLocation().search);
}


function ALPRDetail() {
    let query = useQuery();

    return (
        <div>
            <ALPRDetailInfo ID={query.get("ID")} ALPRObject={query.get("ALPRObject")} department={query.get("Dept")} />
        </div>
    );
}

export default ALPRDetail;